'use strict';

angular
	.module('dcApp')
	.factory('ConnectorService', [
		'$http',
		'$rootScope',
		'API_BASE_URL_BACKEND',
		'ConnectorV2Service',
		'UrlService',
		function (
			$http,
			$rootScope,
			API_BASE_URL_BACKEND,
			ConnectorV2Service,
			UrlService
		) {
			var ConnectorService = {};

			/**
			 * Get connector list
			 * @param excludedTypes
			 *      Connector type to be excluded. This can be a string or an array of string
			 * @param includedTypes
			 *      Connector type to be included. This can be a string or an array of string
			 * @param details
			 *      The service should return a lib and the code or a metadata object. True to return metadata object. Default value true
			 * @returns {*}
			 */
			ConnectorService.getConnectorsList = function (
				excludedTypes,
				includedTypes,
				excludedModes,
				details,
				excludeInactive
			) {
				const url = UrlService.generateUrl('CONNECTORS', {},
					{
						excludeInactive: excludeInactive ? excludeInactive : false,
						details: typeof details === 'boolean' ? details : true,
						excludedTypes: excludedTypes,
						includedTypes: includedTypes,
						excludedModes: excludedModes
					}
				);

				return $http.get(url).then(function (response) {
					return response;
				});
			};

			ConnectorService.getConnectorById = function (connectorId) {
				var url = API_BASE_URL_BACKEND + $rootScope.getUrl('CONNECTORS_BY_ID');
				url = url.replace('{connectorId}', connectorId);
				return $http.get(url).then(function (response) {
					return response;
				});
			};

			ConnectorService.deleteConnectors = function (connectorsIds) {
				var url = API_BASE_URL_BACKEND + $rootScope.getUrl('CONNECTORS');
				if (Array.isArray(connectorsIds)) {
					url = url + '?connectorIds=' + connectorsIds[0];
					for (let i = 1; i < connectorsIds.length; i++) {
						url = url + '&connectorIds=' + connectorsIds[i];
					}
				} else {
					url = url + '?connectorIds=' + connectorsIds;
				}
				return $http.delete(url).then(function (response) {
					return response;
				});
			};

			ConnectorService.listRemoteFilesById = function (
				connectorId,
				path,
				type
			) {
				let url = UrlService.generateUrl(
					'CONNECTORS_V2_FILES_BY_ID',
					{ connectorId: connectorId },
					{ remotePath: encodeURIComponent(path) }
				);

				return $http.get(url).then(function (response) {
					return response;
				});
			};

			ConnectorService.listRemoteFiles = function (connector, path, type) {
				let url = UrlService.generateUrl(
					'CONNECTORS_V2_FILES',
					{},
					{ remotePath: encodeURIComponent(path) }
				);

				return $http.post(url, connector).then(function (response) {
					return response;
				});
			};

			return ConnectorService;
		},
	])
	.factory('ConnectorV2Service', [
		'$http',
		'$rootScope',
		'UrlService',
		'$q',
		function ($http, $rootScope, UrlService, $q) {
			var ConnectorV2Service = {};

			ConnectorV2Service.getConnectors = function () {
				const url = UrlService.generateUrl(
					'CONNECTORS_V2',
					{},
					{}
				);
				return $http.get(url).then(function (response) {
						return response;
					});
			};

			ConnectorV2Service.getConnectorById = function (connectorId) {
				const url = UrlService.generateUrl(
					'CONNECTORS_V2_BY_ID',
					{ connectorId: connectorId },
					{}
				);
				return $http.get(url).then(function (response) {
					return response;
				});
			};

			ConnectorV2Service.createConnector = function (connector) {
				const url = UrlService.generateUrl(
					'CONNECTORS_V2',
					{},
					{}
				);
				return $http.post(url, connector).then(function (response) {
						return response;
					});
			};

			ConnectorV2Service.editConnector = function (
				connectorId,
				connector
			) {
				const url = UrlService.generateUrl(
					'CONNECTORS_V2_PRIVATE_BY_ID',
					{ connectorId: connectorId },
					{}
				);
				return $http.put(url, connector).then(function (response) {
					return response;
				});
			};

			ConnectorV2Service.deleteConnector = function (connectorId) {
				const url = UrlService.generateUrl(
					'CONNECTORS_V2_PRIVATE_BY_ID',
					{ connectorId: connectorId },
					{}
				);
				return $http.delete(url).then(function (response) {
					return response;
				});
			};

			ConnectorV2Service.checkConnection = function (connector) {
				const url = UrlService.generateUrl(
					'CONNECTORS_V2_CHECK_CONNECTION',
					{},
					{}
				);
				return $http.post(url, connector).then(function (response) {
						return response;
					});
			};

			ConnectorV2Service.getSimilarDBConnectors = function (connectorId, excludedModes) {
				const url = UrlService.generateUrl(
					'CONNECTORS_V2_SIMILAR',
					{ connectorId: connectorId },
					{ excludedModes: excludedModes }
				);
				return $http.get(url).then(function (response) {
					return response;
				});
			};

			ConnectorV2Service.getMongodbCollections = function (connectorId) {
				const url = UrlService.generateUrl(
					'CONNECTORS_V2_MONGODB_COLLECTION_BY_ID',
					{ connectorId: connectorId },
					{}
				);
				return $http.get(url).then(function (response) {
					return response;
				});
			};

			return ConnectorV2Service;
		},
	]);
